module.exports = __webpack_public_path__ + "za.svg?9b853c8e417423eca58096f1eedc40da";